import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Linking, View } from 'react-native';
import { useState } from 'react';
import { Modal } from 'app/design/primitives/modal';
import { Button } from 'app/design/primitives/button';
import { useTranslation } from 'react-i18next';
import { isMobileNative } from 'app/utils/constants';
export function useOpenSettingsPrompt() {
  const [isSettingsPromptOpen, setIsSettingsPromptOpen] = useState(false);
  return {
    isSettingsPromptOpen,
    openSettingsPrompt: () => setIsSettingsPromptOpen(true),
    closeSettingsPrompt: () => setIsSettingsPromptOpen(false),
  };
}

function OpenSettingsPrompt({
  isOpen,
  onClose,
  settingName,
}: {
  isOpen: boolean;
  onClose: () => void;
  settingName: 'notification' | 'camera';
}) {
  const { t } = useTranslation('settingsPrompt');

  const onPress = () => {
    if (isMobileNative) {
      void Linking.openSettings().catch(() => undefined);
    }
    // Always close the modal, even on web where openSettings is not available
    onClose();
  };

  return (
    <Modal onClose={onClose} open={isOpen} transparent>
      <Modal.Card>
        <Modal.Title>{t(`${settingName}.title`)}</Modal.Title>

        <Column>
          <Text textAlign="center">{t(`${settingName}.text`)}</Text>
        </Column>

        <View>
          <Button marginBottom="spacing.general.x4" onPress={onPress} variant="primary">
            {t('primaryButtonText')}
          </Button>

          <Button onPress={onClose} variant="secondary">
            {t('secondaryButtonText')}
          </Button>
        </View>
      </Modal.Card>
    </Modal>
  );
}

export { OpenSettingsPrompt };
